<a
	class="card-block copo-clickable"
	mat-ripple
	[routerLink]="['/quality-issues/card', claimDisplayed.id]"
>

	<!-- Title -->
	<div class="order-tracking-list-card-header">
		<span>{{claimDisplayed.reference}}</span>
		<div class="copo-header-ton">{{claimDisplayed.status | translate}}</div>
	</div>

	<!-- Amount, creation and modification dates -->
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>claim.requested.amount</span>
			<span class="order-card-value">{{ claimDisplayed.amount ? (claimDisplayed.amount | copoNumber:'amount':getUnitAmount(claimDisplayed.currency)) : UNDERSCORE }}</span>
		</div>
	</div>
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>claim.created</span>
			<span class="order-card-value">{{ claimDisplayed.creationDate | copoDate:'datetime' }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>claim.last.modification</span>
			<span class="order-card-value">{{ claimDisplayed.modicationDate | copoDate:'datetime' }}</span>
		</div>
	</div>

</a>

